// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"80693a59","291":"2313630c","452":"71cb184b","744":"3bf2f88b"}[chunkId] + ".chunk.js";
};